import React, { useState, useEffect, useCallback } from 'react';
import { Button, Dropdown } from 'react-bootstrap';

import Table, { RowType } from '../Shared/CustomTable';
import { isBlankString, arraySort, text_truncate } from '../../helpers/helpers';
import {
  ENTITY_STATUS_FILTER,
  ENTITY_MODEL_FILTER,
  LEFT,
  RIGHT,
  CENTER,
  POSITION,
  STATUS,
  FILTER_KEYS,
  SCOPE,
  ENTITY_VALUES,
  LEAGUES,
  POSITION_LACROSSE,
  ENTITY_MODEL_TYPES,
  NFL_GAME
} from '../../config/constants';
import EditableTag from './EditableTag';
import EditableField from './EditableField';
import SelectableField from './SelectableField';
import Loader from '../Shared/Loader';
import { useEntitiesState, useFiltersState } from '../../store/hooks';
import { useRouter } from '../../helpers/customHooks';
import {Entity, Tag, EntitiesTableProps} from './types';

/**
 *
 *
 * @param {Function}      editEntity                from mapDispatchToProps
 * @param {Function}      modalOpener               own props
 * @param {boolean}       editable                  own props
 * @param {Function}      openConfirmationModal     own props
 * @param {Function}      setDrawerVisible          own props
 * @returns React.Component
 */


export default ({
                  editable, drawerVisible, alertCount,
                  editEntity, modalOpener, openConfirmationModal, setDrawerVisible,
                  computeRepeatedTags, openTagsConfirmationModal, league, leagueType
                }: EntitiesTableProps) => {

  const { entitiesObject, isDataOpsPage } = useEntitiesState();
  const { specificScope } = useRouter();
  const {[FILTER_KEYS.TARGETED_RETRACK]:isTargetedRetrack=false} = useFiltersState(specificScope, FILTER_KEYS.TARGETED_RETRACK);
  const [onTableEntities, setOnTableEntities] = useState<Entity[]>([]);
  const [entitiesArray, setEntitiesArray] = useState<Entity[]>([]); // fixed array, unchanging but when entitiesObject changes

  const [nameSpaceIdFilter, setNameSpaceIdFilter] = useState('');
  const [nflIdFilter, setNflIdFilter] = useState('');
  const [jerseyNumberFilter, setJerseyNumberFilter] = useState<number | string>('');
  const [nameFilter, setNameFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState(ENTITY_STATUS_FILTER.default);
  const [modelFilter, setModelFilter] = useState(ENTITY_MODEL_FILTER.default);
  const [positionFilter, setPositionFilter] = useState('No Filter'); //TODO: constants

  // needed for online editing in table
  const [savedEntityId, setSavedEntityId] = useState<string|undefined|null>(undefined);
  const [onlineNflId, setOnlineNflId] = useState<number | null>(null);
  // const [onlineName, setOnlineName] = useState(null);
  const [onlineJerseyNumber, setOnlineJerseyNumber] = useState<number|null>(null);
  const [onlineStatus, setOnlineStatus] = useState<string | null>(null);
  const [onlinePosition, setOnlinePosition] = useState<string | null>(null);
  const [entitiesId, setEntitiesId] = useState('');

  const openDrawer = () => {
    if (alertCount && alertCount.current && alertCount.current > 0) {
      setDrawerVisible(true);
    }
  };

  const filter = (nameSpaceId:string, nflId:string, jerseyNumber:any, name:string, status:string, model:string, position:string) => {
    if (isBlankString(nameSpaceId) && isBlankString(nflId) && isBlankString(jerseyNumber) &&
      isBlankString(name) && status === ENTITY_STATUS_FILTER.default && model === ENTITY_MODEL_FILTER.default && position === 'No Filter') { //TODO: constants
      setOnTableEntities(entitiesArray);
      return;
    }
    const regexNameSpaceId = isBlankString(nameSpaceId) ? null : new RegExp(nameSpaceId.trim(), 'i');//TODO: understand regex
    const regexNflId = isBlankString(nflId) ? null : new RegExp(nflId.trim(), 'i');
    const regexJerseyNumber = isBlankString(jerseyNumber) ? null : new RegExp(jerseyNumber.trim(), 'i');
    const regexName = isBlankString(name) ? null : new RegExp(name.trim(), 'i');

    setOnTableEntities(entitiesArray.filter((entity:Entity) => {
      if (regexNameSpaceId) {
        if (entity && entity.namespaced_id) {
          if (!regexNameSpaceId.test(entity.namespaced_id)) {
            return false;
          }
        } else {
          return false;
        }
      }

      if (regexNflId) {
        if (entity && entity.extra_data && entity.extra_data.nflId) {
          if (!regexNflId.test(String(entity.extra_data.nflId))) {
            return false;
          }
        } else {
          return false;
        }
      }

      if (regexJerseyNumber) {
        if (entity && entity.extra_data && entity.extra_data.jerseyNumber) {
          if (!regexJerseyNumber.test(String(entity.extra_data.jerseyNumber))) {
            return false;
          }
        } else {
          return false;
        }
      }

      if (regexName) {
        if (entity && entity.name) {
          if (!regexName.test(entity.name)) {
            return false;
          }
        } else {
          return false;
        }
      }

      if (status !== ENTITY_STATUS_FILTER.default) {
        if (entity && entity.extra_data && entity.extra_data.status) {
          if (entity.extra_data.status !== status) {
            return false;
          }
        } else {
          return false;
        }
      }

      if (model !== ENTITY_MODEL_FILTER.default) {
        if (entity && entity.model) {
          if (entity.model !== model) {
            return false;
          }
        } else {
          return false;
        }
      }

      if (position !== 'No Filter') {
        if (entity && entity.extra_data.position) {
          if (entity.extra_data.position !== position) {
            return false;
          }
        } else {
          return false;
        }
      }

      return true;
    }));
  };

  const nameSpaceIdFilterHandler = (event:React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value !== ' ') {
      setNameSpaceIdFilter(event.target.value);
      filter(event.target.value, nflIdFilter, jerseyNumberFilter, nameFilter, statusFilter, modelFilter, positionFilter);
    }
  };
  const nflIdFilterHandler = (event:React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value !== ' ') {
      setNflIdFilter(event.target.value);
      filter(nameSpaceIdFilter, event.target.value, jerseyNumberFilter, nameFilter, statusFilter, modelFilter, positionFilter);
    }
  };
  const numberFilterHandler = (event:React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value !== ' ') {
      setJerseyNumberFilter(event.target.value);
      filter(nameSpaceIdFilter, nflIdFilter, event.target.value, nameFilter, statusFilter, modelFilter, positionFilter);
    }
  };
  const nameFilterHandler = (event:React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value !== ' ') {
      setNameFilter(event.target.value);
      filter(nameSpaceIdFilter, nflIdFilter, jerseyNumberFilter, event.target.value, statusFilter, modelFilter, positionFilter);
    }
  };

  const statusFilterHandler = (value:string) => {
    setStatusFilter(value);
    filter(nameSpaceIdFilter, nflIdFilter, jerseyNumberFilter, nameFilter, value, modelFilter, positionFilter);
  };

  const modelFilterHandler = (value:string) => {
    setModelFilter(value);
    filter(nameSpaceIdFilter, nflIdFilter, jerseyNumberFilter, nameFilter, statusFilter, value, positionFilter);
  };

  const positionFilterHandler = (value:string) => {
    setPositionFilter(value);
    filter(nameSpaceIdFilter, nflIdFilter, jerseyNumberFilter, nameFilter, statusFilter, modelFilter, value);
  };

  const handleEntityNflIdChange = useCallback(value => setOnlineNflId(value), []);
  const handleEntityJerseyNumberChange = useCallback(value => setOnlineJerseyNumber(parseInt(value)), []);
  const handleEntityStatusChange = useCallback(value => setOnlineStatus(value), []);
  const handleEntityPositionChange = useCallback(value => setOnlinePosition(value), []);
  // const handleEntityNameChange = useCallback(value => setOnlineName(value), []);

  const onSaveEntityClick = (entity:Entity) => {
      const newId = entity && entity._id.valueOf();
      setEntitiesId(entity.id.valueOf().toString());
      setSavedEntityId(newId);
  };

  const cleanOnlineValues = () => {
    setOnlineJerseyNumber(null);
    setOnlineNflId(null);
    setOnlineStatus('');
    setOnlinePosition('');
  };

  useEffect(() => {
    if (savedEntityId && entitiesObject[entitiesId]._id === savedEntityId && (onlineNflId || onlineJerseyNumber || onlinePosition || onlineStatus)) {
      const newEntity = entitiesObject[entitiesId];
      // newEntity['name'] = onlineName;
      if (newEntity) {
        newEntity['extra_data']['nflId'] = onlineNflId;
        newEntity['extra_data']['jerseyNumber'] = onlineJerseyNumber;
        newEntity['extra_data']['status'] = onlineStatus;
        newEntity['extra_data']['position'] = onlinePosition;
        newEntity['extra_data']['positionGroup'] = POSITION.types.find(position => position.name === onlinePosition)?.value.group;
        editEntity(newEntity, newEntity.extra_data);
        setSavedEntityId(undefined);
        cleanOnlineValues();
      }
    } else {
      setSavedEntityId(undefined);
      cleanOnlineValues();
    }
  }, [onlineJerseyNumber, onlineNflId, onlineStatus, onlinePosition]);

  // when entities object arriving the component change
  // all filters are reset to their default values
  useEffect(() => {
    let newEntitiesArray = Object.values(entitiesObject) as Array<Entity|string>;

    if (newEntitiesArray[0] === '') {
      newEntitiesArray = [];
    }
    setEntitiesArray(newEntitiesArray as Entity[]);
  }, [entitiesObject]);

  useEffect(() => {
    setPositionFilter('No Filter');
    setOnTableEntities(entitiesArray);
    // cleanAllFilters();
    if (computeRepeatedTags) {
      computeRepeatedTags(entitiesArray);
    }
    filter(nameSpaceIdFilter, nflIdFilter, jerseyNumberFilter, nameFilter, statusFilter, modelFilter, positionFilter);
    setSavedEntityId(undefined);
    cleanOnlineValues();
    if (!!computeRepeatedTags && drawerVisible === undefined) {
      openDrawer();
    }
  }, [entitiesArray, league]);
  useEffect(() => {
    if (drawerVisible === true && computeRepeatedTags) {
      computeRepeatedTags(entitiesArray);
    }
  }, [drawerVisible]);

  const statusFilterDropdownItems = ENTITY_STATUS_FILTER.types.map((type, index) =>
    <Dropdown.Item key={index} onClick={() => statusFilterHandler(type)} active={statusFilter === type}>
      {type}
    </Dropdown.Item>
  );

  const modelFilterDropdownItems = ENTITY_MODEL_FILTER.types.map((type, index) =>
    <Dropdown.Item key={index} onClick={() => modelFilterHandler(type)} active={modelFilter === type}>
      {type}
    </Dropdown.Item>
  );

  const positionFilterDropdownItems = [...POSITION.types, { value: { position: 'No Filter' } }].map((type, index) =>
    <Dropdown.Item
      key={index} onClick={() => positionFilterHandler(type.value.position)}
      active={positionFilter === type.value.position}
    >
      {type.value.position}
    </Dropdown.Item>
  );
  const positionMlaxFilterDropdownItems = [...POSITION_LACROSSE.types, { name: 'No Filter'  }].map((type, index) =>
    <Dropdown.Item
      key={index} onClick={() => positionFilterHandler(type.name)}
      active={positionFilter === type.name}
    >
      {type.name}
    </Dropdown.Item>
  );
  
  
  const headers = [
    ...(isDataOpsPage && isTargetedRetrack ? [{ isCheckboxCell: true, isSelectable: true, style: { width: '34px' } }] : []), 
    //isCheckboxCell: put in content a checkbox, isSelectable: select all or nothing
    {
      content: 'NAME SPACE',
      style: { width: isDataOpsPage&&isTargetedRetrack? '107px' : '130px', verticalAlign: 'top', minWidth: isTargetedRetrack? '107px':'130px' },
      class: 't-ll',
      isOrderly: !editable,
      print: (content:string) => <>{content}<input
        className="input-01"
        type="text" placeholder="Search" value={nameSpaceIdFilter}
        onClick={e => e.stopPropagation()}
        onChange={event => nameSpaceIdFilterHandler(event)}
        disabled={editable}
      /></>
    },
    {
      content: 'NFL ID',
      style: { width: isDataOpsPage&&isTargetedRetrack ? '140px' : '130px', verticalAlign: 'top', minWidth: isTargetedRetrack? '140px':'130px' },
      class: 't-ll',
      isOrderly: !editable,
      print: (content:string) => <>{content}<input
        className="input-02"
        type="text" placeholder="Search" value={nflIdFilter}
        onClick={e => e.stopPropagation()}
        onChange={event => nflIdFilterHandler(event)}
        disabled={editable}
      /></>
    },
    {
      content: '#',
      style: { width: isDataOpsPage&&isTargetedRetrack ? '56px' : '73px', verticalAlign: 'top', textDecoration: 'underline', minWidth: isTargetedRetrack? '56px':'73px' },
      class: 't-ll',
      isOrderly: !editable,
      print: (content:string) => (
        <>
          {content}
          <br />
          <input
            className="input-03"
            style={{
              marginLeft: '-4px',
              width: '32px',
              marginRight: '-4px',
              padding: '0 3px'
            }}
            type="text" placeholder="" value={jerseyNumberFilter}
            onClick={e => e.stopPropagation()}
            onChange={event => numberFilterHandler(event)}
            disabled={editable}
          />
        </>
      )
    },
    {
      content: 'NAME',
      style: { width: isDataOpsPage&&isTargetedRetrack ? '140px' : '144px', verticalAlign: 'top', minWidth: isTargetedRetrack? '140px':'144px' },
      class: 't-ll', isOrderly: !editable,
      print: (content:string) => <>{content}<input
        className="input-04"
        type="text" placeholder="Search" value={nameFilter}
        onClick={e => e.stopPropagation()}
        onChange={event => nameFilterHandler(event)}
        disabled={editable}
      /></>
    },
    {
      content: 'STATUS',
      style: { width: isDataOpsPage&&isTargetedRetrack ? '100px' : '108px', verticalAlign: 'top', minWidth: isTargetedRetrack? '100px':'108px' },
      class: 't-ll',
      isOrderly: !editable,
      print: (content:string) => (<>{content}
        <div onClick={event => event.stopPropagation()}>
          <Dropdown className="entities-dd">
            <Dropdown.Toggle className="button-000" disabled={editable}>
              {statusFilter}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {statusFilterDropdownItems}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </>)
    },
    {
      content: 'MODEL',
      style: { width: isDataOpsPage&&isTargetedRetrack ? '103px' : '108px', verticalAlign: 'top', minWidth: isTargetedRetrack? '103px':'108px' },
      class: 't-ll',
      isOrderly: !editable,
      print: (content:string) => (<>{content}
        <div onClick={event => event.stopPropagation()}>
          <Dropdown className="entities-dd">
            <Dropdown.Toggle className="button-000" disabled={editable}>
              {modelFilter}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {modelFilterDropdownItems}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </>)
    },
    {
      content: 'POS',
      style: { width: isDataOpsPage&&!isTargetedRetrack? '89px':'107px', verticalAlign: 'top', minWidth:isDataOpsPage&&!isTargetedRetrack? '89px':'107px' },
      class: 't-ll position-column',
      isOrderly: !editable,
      print: (content:string) => (<>{content}
        <div onClick={event => event.stopPropagation()}>
          <Dropdown className="entities-dd entities-position" style={{ maxWidth: '50px' }}>
            <Dropdown.Toggle className="button-000" disabled={editable}>
              {text_truncate(positionFilter, 5)}
            </Dropdown.Toggle>
            <Dropdown.Menu className="menu-00l" style={{ height: '150px', overflowY: 'scroll' }}>
              {league === LEAGUES.MLAX ? positionMlaxFilterDropdownItems : positionFilterDropdownItems }
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </>)
    },
    { content: 'LEFT', style: { width: '113px', verticalAlign: 'top' }, class: 't-ll', isOrderly: !editable },
    { content: 'RIGHT', style: { width: '113px', verticalAlign: 'top' }, class: 't-ll',isOrderly: !editable },
    { content: 'CENTER', style: { width: '113px', verticalAlign: 'top' }, isOrderly: !editable},

    { content: (!isDataOpsPage&&!isTargetedRetrack) && leagueType === NFL_GAME? 'DELETE ALL TAGS': '' ,style: {
        width: isDataOpsPage&&!isTargetedRetrack?'148px': isTargetedRetrack? '141px' : '133px',
        verticalAlign: 'top', minWidth: isDataOpsPage&&!isTargetedRetrack?'148px':  isTargetedRetrack? '141px': '133px',
        maxWidth: isDataOpsPage&&!isTargetedRetrack?'148px': isTargetedRetrack? '141px':'133px'
      },
      print: (content: string) => {
  if (
    !isDataOpsPage &&
    !isTargetedRetrack &&
    leagueType === NFL_GAME &&
    editable
  ) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', gap: '4px' }}>
          <div style={{ fontWeight: 'bold' }}>{content}</div>
          <button
            className="trash-00-entities"
            onClick={openTagsConfirmationModal}
            style={{ background: 'none', border: 'none', padding: 0 }}
          >
            <img
              src="/assets/trash.svg"
              alt="delete tags"
              height="16px"
              style={{ marginTop: '-4px' }}
            />
          </button>
        </div>
      </div>
    );
  }

  return null;
}
}
  ];
  const emptyCell = (
    <div style={{ height: '30px', width: '62px', display: 'inline-block', marginTop: '5px' }}  />
  );
  let rows:RowType[] = [];
  if (onTableEntities) {
    rows = onTableEntities.map((entity, index) => {
      const tagsByGroup = {};
      let emptyTags = false;
      entity?.tags.forEach((tag) => { // two tags can have different group and same tagGroupId or vice versa
        if (tag.name && tag.group) {
          if (!tagsByGroup[tag.group]) {
            tagsByGroup[tag.group] = [];
          }
          tagsByGroup[tag.group].push(tag);
        }
        if(entity && entity.model !== ENTITY_MODEL_TYPES.GAME_BALL && !tag.name){
          emptyTags= true;
        }
      });
      const leftTags = [];
      const rightTags = [];
      const centerTags = [];
      for (const group in tagsByGroup) {
        let leftCount = 0;
        let rightCount = 0;
        let centerCount = 0;
        tagsByGroup[group].forEach((tag:Tag, tagIndex:number) => {
          if (tag.name && new RegExp(LEFT, 'i').test(tag.name)) {
            leftCount++;
            leftTags.push(
              <EditableTag
                editable={editable}
                tag={tag}
                key={String(index) + String(tag._id) + String(tagIndex)}
                entityIndex={index}
                editEntity={editEntity}
                onTableEntities={onTableEntities}
              />
            );
          } else if (tag.name && new RegExp(RIGHT, 'i').test(tag.name)) {
            rightCount++;
            rightTags.push(
              <EditableTag
                editable={editable}
                tag={tag}
                key={String(index) + String(tag._id) + String(tagIndex)}
                entityIndex={index}
                editEntity={editEntity}
                onTableEntities={onTableEntities}
              />
            );
          } else if (tag.name && (new RegExp(CENTER, 'i').test(tag.name) || (entity && entity.type && entity.type === ENTITY_VALUES.BALL))) {
            centerCount++;
            centerTags.push(
              <EditableTag
                editable={editable}
                tag={tag}
                key={String(index) + String(tag._id) + String(tagIndex)}
                entityIndex={index}
                editEntity={editEntity}
                onTableEntities={onTableEntities}
              />
            );
          } else if (tag?.offset?.join(',') === [0.5, 0, 0].join(',')) {
            leftCount++;
            leftTags.push(
              <EditableTag
                editable={editable}
                tag={tag}
                key={String(index) + String(tag._id) + String(tagIndex)}
                entityIndex={index}
                editEntity={editEntity}
                onTableEntities={onTableEntities}
              />
            );
          } else if (tag?.offset?.join(',') === [-0.5, 0, 0].join(',')) {
            rightCount++;
            rightTags.push(
              <EditableTag
                editable={editable}
                tag={tag}
                key={String(index) + String(tag._id) + String(tagIndex)}
                entityIndex={index}
                editEntity={editEntity}
                onTableEntities={onTableEntities}
              />
            );
          } else if (tag?.offset?.join(',') === [0, 0, 0].join(',')) {
            centerCount++;
            centerTags.push(
              <EditableTag
                editable={editable}
                tag={tag}
                key={String(index) + String(tag._id) + String(tagIndex)}
                entityIndex={index}
                editEntity={editEntity}
                onTableEntities={onTableEntities}
              />
            );
          }
        });
        const maxCount = Math.max(leftCount, rightCount, centerCount);
        leftTags.push(...new Array(maxCount - leftCount).fill(emptyCell));
        rightTags.push(...new Array(maxCount - rightCount).fill(emptyCell));
        centerTags.push(...new Array(maxCount - centerCount).fill(emptyCell));
      }
      let counterEmpty: number;
      let counterIndex: number;
      return ({
        id: ''+entity?.id,
        columns: [
          ...(isDataOpsPage && isTargetedRetrack ? [{}] : []),
          {
            isCheckboxCell: isDataOpsPage&&isTargetedRetrack? true: false,
            content: { namespaceId: entity?.namespaced_id, namespaceIdSplited: entity?.namespaced_id?.split('_') },
            class: 't-ll',
            style: isDataOpsPage&&isTargetedRetrack? {minWidth: '107px', maxWidth: '107px', width:'107px'} : {},
            print: content => <label className="pp-ww">{content.namespaceId}</label>,
            order: (contentA, contentB) => {
              if (!Number.isNaN(+contentA.namespaceId) && !Number.isNaN(+contentB.namespaceId)) {
                return +contentB.namespaceId - +contentA.namespaceId;
              }
              return arraySort(contentB.namespaceIdSplited, contentA.namespaceIdSplited);
            }
          },
          {
            isCheckboxCell: isDataOpsPage&&isTargetedRetrack? true: false,
            content: entity?.extra_data?.nflId ? entity.extra_data.nflId : '',
            class: 't-ll tt-qq-0',
            style: isDataOpsPage&&isTargetedRetrack? { width: '140px', minWidth: '140px', maxWidth: '140px' } : {},
            print: content => editable ? <EditableField
              text={content}
              className="input-edit"
              saveClickObserver={savedEntityId === entity?._id ? handleEntityNflIdChange : ()=>{}}
              // itemId={entity.id}
              // handleChange={handleEntityNflIdChange}
            /> : <label className="pp-ww">{content}</label>,
            order: (contentA, contentB) => {
              if (!Number.isNaN(+contentA) && !Number.isNaN(+contentB)) {
                return +contentB - +contentA;
              } else if (!Number.isNaN(+contentA)) {
                return -1;
              } else if (!Number.isNaN(+contentB)) {
                return 1;
              }
              return 0;
            }
          },
          {
            isCheckboxCell: isDataOpsPage&&isTargetedRetrack? true: false,
            content: entity?.extra_data && entity?.extra_data.jerseyNumber?.toString ? {
              displayNumber: text_truncate(String(entity?.extra_data.jerseyNumber), 4),
              //@ts-ignore
              orderNumber: entity?.extra_data?.jerseyNumber === '' ? '999999' : entity.extra_data.jerseyNumber.toString()
            } : {
              displayNumber: '',
              orderNumber: '999999'
            },
            style: isDataOpsPage&&isTargetedRetrack? {width: '56px', minWidth:'56px',  maxWidth: '56px'} : {},
            class: 't-ll tt-qq-0',
            print: content => editable ? <EditableField
              text={content.displayNumber ? content.displayNumber : ''}
              className="input-edit"
              saveClickObserver={savedEntityId === entity?._id ? handleEntityJerseyNumberChange : ()=>{}}
              // itemId={entity.id}
              // handleChange={handleEntityJerseyNumberChange}
            /> : <label className="pp-ww">{content.displayNumber ? content.displayNumber : ''}</label>,
             order: (contentA, contentB) => {
                const jerseyA =  contentA.orderNumber.replace(/\D/g, '');
                const jerseyB =  contentB.orderNumber.replace(/\D/g, '');
                const jerseyLetterA = contentA.orderNumber.replace(jerseyA, '');
                const jerseyLetterB = contentB.orderNumber.replace(jerseyB, '');
                if (+jerseyA !== +jerseyB) {
                  return +jerseyB- +jerseyA;
                   
                }
                return jerseyLetterB.localeCompare(jerseyLetterA);
                
              }
          },
          {
            isCheckboxCell: isDataOpsPage&&isTargetedRetrack? true: false,
            content: { name: entity?.name, lastName: entity?.extra_data.lastName, type: entity.type},
            class: 't-ll tt-qq-0',
            style: isDataOpsPage&&isTargetedRetrack? {width: '140px', maxWidth: '140px', minWidth: '140px'} : {},
            print: content => <label className="pp-ww">{content.name}</label>,
            order: (contentA, contentB) => {
            const typeA = contentA.type;
            const typeB = contentB.type;

            if (typeA === 'player' && typeB === 'ball') return 1;  
            if (typeA === 'ball' && typeB === 'player') return -1;

            if (typeA === 'ball' && typeB === 'ball') {
              return +contentB.name - +contentA.name;
            }

           if (typeA === 'player' && typeB === 'player') {
              return contentB.lastName.localeCompare(contentA.lastName); // inverted
            }
            return 0;
            }
          },
          {
            isCheckboxCell: isDataOpsPage&&isTargetedRetrack? true: false,
            content: entity?.extra_data?.status ? entity?.extra_data.status : '',
            class: 't-ll',
            style: isDataOpsPage&&isTargetedRetrack? {width: '100px', maxWidth: '100px', minWidth: '100px'} : {},
            print: content => editable ? <SelectableField
              content={content}
              saveClickObserver={savedEntityId === entity?._id ? handleEntityStatusChange : ()=>{}}
              options={STATUS}
            /> : <label className="pp-ww">{content}</label>
          },
          {
            isCheckboxCell: isDataOpsPage&&isTargetedRetrack? true: false,
            content: entity?.model,
            class: 't-ll',
            style: isDataOpsPage&&isTargetedRetrack? {width: '103px', maxWidth: '103px', minWidth: '103px'} : {maxWidth:"108px"},
            print: content => <label className="pp-ww">{content}</label>
          },
          {
            isCheckboxCell: isDataOpsPage&&isTargetedRetrack? true: false,
            content: entity?.extra_data?.position ? entity?.extra_data.position : '',
            class: 't-ll',
            style: editable ? //TODO: check another way to handle different
              { maxWidth: '107px' } :
              isDataOpsPage&&isTargetedRetrack?
                {width: '107px' } : //TODO: check if max and min width are necessary or not
                isDataOpsPage&&!isTargetedRetrack?
                  {width: '89px' } : {},
            print: content => editable ? <SelectableField
              content={content}
              saveClickObserver={savedEntityId === entity?._id ? handleEntityPositionChange : ()=>{}}
              options={POSITION}
            /> : <label className="pp-ww">{content}</label>
          },
          {
            isCheckboxCell: isDataOpsPage&&isTargetedRetrack? true: false,
            counterEmpty: counterEmpty = 0,
            counterIndex: counterIndex = 0,
            content: leftTags.length !== 0 ? {
            displayTag: leftTags,
            checkTag: leftTags.map((index) =>{
              if(index === emptyCell){
                counterEmpty++;
              }
              counterIndex++;
              
            }), //leftTags.length === 0 || leftTags.includes(emptyCell) ? 'empty' : 'not empty',
            isCheckboxCell: isDataOpsPage&&isTargetedRetrack? true: false,
            orderTag: counterEmpty === counterIndex ? 99999 : 1, 
            }
            :
            {
              displayTag: leftTags,
              orderTag: 999999
            },
            class: 't-ll tt-qq-0',
            style: editable ?
              { padding: '9px 10px' } :
              isDataOpsPage&&isTargetedRetrack?
                { width: '105px', minWidth: '105px', maxWidth: '105px' } :  //TODO: check if max and min width are necessary or not
                isDataOpsPage&&!isTargetedRetrack ?
                  {maxWidth: '105px', minWidth: '105px', width:'105px'} :{},
                  print: content => content.displayTag,
                  order: (contentA, contentB) => {
                    if (!Number.isNaN(+contentA.orderTag) && !Number.isNaN(+contentB.orderTag)) {
                      return +contentB.orderTag - +contentA.orderTag;
                    }
                    return arraySort(contentB.orderTag, contentA.orderTag);
                  } 
                },
                  
          {
            isCheckboxCell: isDataOpsPage&&isTargetedRetrack? true: false,
            counterEmpty: counterEmpty = 0,
            counterIndex: counterIndex = 0,
            content: rightTags.length !== 0 ? {
            displayTag: rightTags,
            checkTag: rightTags.map((index) =>{
              if(index === emptyCell){
                counterEmpty++;
              }
              counterIndex++;
              
            }),
            orderTag: counterEmpty === counterIndex ? 999999 : 1, 
            }
            :
            {
              displayTag: rightTags,
              orderTag: 999999
            },
            class: 't-ll tt-qq-0',
            style: editable ?
              { padding: '9px 10px' } :
              isDataOpsPage&&isTargetedRetrack?
                { width: '107px', minWidth: '107px', maxWidth: '107px' } :
                isDataOpsPage&&!isTargetedRetrack ?
                {maxWidth: '106px', minWidth: '106px', width:'106px'}: {},
                print: content => <label className="pp-ww">{content.displayTag}</label>,
                order: (contentA, contentB) => {
                  if (!Number.isNaN(+contentA.orderTag) && !Number.isNaN(+contentB.orderTag)) {
                    return +contentB.orderTag - +contentA.orderTag;
                  }
                  return arraySort(contentB.orderTag, contentA.orderTag);
                }
              },
          {
            isCheckboxCell: isDataOpsPage&&isTargetedRetrack? true: false,
            counterEmpty: counterEmpty = 0,
            counterIndex: counterIndex = 0,
            content: centerTags.length !== 0 ? {
            displayTag: centerTags,
            checkTag: centerTags.map((index) =>{
              if(index === emptyCell){
                counterEmpty++;
              }
              counterIndex++;
              
            }),
            orderTag: counterEmpty === counterIndex ? 999999 : 1, 
            }
            :
            {
              displayTag: centerTags,
              orderTag: 999999
            },
            class: 'tt-qq-0',
            style: editable ?
              { padding: '9px 10px', minWidth: '109px', width: '109px' } :
              isDataOpsPage&&isTargetedRetrack?
                { width: '113px', maxWidth: '113px', minWidth: '113px' } :
                { maxWidth: '108px', minWidth: '108px', width:'108px' },
                print: content => content.displayTag,
                order: (contentA, contentB) => {
                  if (!Number.isNaN(+contentA.orderTag) && !Number.isNaN(+contentB.orderTag)) {
                    return +contentB.orderTag - +contentA.orderTag;
                  }
                  return arraySort(contentB.orderTag.toString(), contentA.orderTag.toString());
                }
              },
          {
            isCheckboxCell: isDataOpsPage&&isTargetedRetrack? true: false,
            class: 'tt-qq-0 uu-ss',
            style: isDataOpsPage&&isTargetedRetrack?
              { paddingLeft: '0', paddingRight: '8px', width: '136px', maxWidth: '136px', minWidth: '136px' } :
              !isTargetedRetrack&&isDataOpsPage?
                { maxWidth:'144px', minWidth:'144px', width:'144px' } :
                { maxWidth:'136px', width:'136px', minWidth: '136px',paddingLeft: '0', paddingRight: '8px' },
            print: () => (
              <>
                <Button disabled={entity._id? false : true} className="btn-gray" onClick={() => openConfirmationModal(entity)}>Delete</Button>
                <Button
                  disabled={entity._id ? false : true}
                  className={editable ? 'btn-green' : emptyTags? 'btn-orange' : entity._id ? 'btn-blue' : 'btn-gray'}
                  style={editable ? { width: '53px' } : emptyTags ? {width: '53px', float:'right'} : {}}
                  onClick={!editable ?
                    () => modalOpener('edit', entity) :
                    () => onSaveEntityClick(entity)
                  }
                >
                  {editable ? 'Save' : 'Edit'}
                </Button>
              </>
            )
          }
        ]
      });
    });
  }
  return (
    <Loader forceScope={isDataOpsPage ? 'DATAOPS_ENTITIES_TEST' : undefined}> {/*TODO: constants scope */}
      <Table
        isSelectedStyle
        classTable={isDataOpsPage ? 'entities-table-entities' : 'entities-table'}
        headers={headers}
        rows={rows}
        default={isDataOpsPage ? { orderColumn: 0 } : { orderColumn: 3 }}
      />
    </Loader>
  );
};
